const textStyle = ({
    textCenter: {
        textAlign: 'center',
    },
});

export default textStyle;